/* Copyright 2013 - 2024 Waiterio LLC */
// import { pickMap } from '../forage/MapsForage.js'
// import { pickMenu } from '../forage/MenusForage.js'
// import { pickRestaurant } from '../forage/RestaurantsForage.js'
// import { pickUser } from '../forage/UsersForage.js'

import clearSession from './clearSession.js'
import getCurrentUserId from './getCurrentUserId.js'
import getCurrentRestaurantId from './getCurrentRestaurantId.js'
import getDefaultMenuId from './getDefaultMenuId.js'
import getPreviousAppVersion from './getPreviousAppVersion.js'
import setPreviousAppVersion from './setPreviousAppVersion.js'
import version from '../version.js'

export default function isLoggedInSession() {
  let isLoggedIn = false

  const currentUserId = getCurrentUserId()
  const currentRestaurantId = getCurrentRestaurantId()
  const defaultMenuId = getDefaultMenuId()
  const previousAppVersion = getPreviousAppVersion()

  if (!previousAppVersion) {
    setPreviousAppVersion(version)
  }

  const validCurrentUserId = currentUserId && currentUserId.length > 0
  const validCurrentRestaurantId =
    currentRestaurantId && currentRestaurantId.length > 0
  const validDefaultMenuId = defaultMenuId && defaultMenuId.length > 0

  if (validCurrentUserId && validCurrentRestaurantId && validDefaultMenuId) {
    // var validCurrentUser = pickUser(currentUserId);
    // var validCurrentRestaurant = pickRestaurant(currentRestaurantId);
    // var validDefaultMenu = pickMenu(defaultMenuId);
    //
    // var validMap = true; //pickMap() !== undefined;
    //
    // if (validCurrentUser && validCurrentRestaurant && validMap) {
    isLoggedIn = true
    // }
  }

  if (!isLoggedIn) {
    clearSession()
  }

  return isLoggedIn
}
